export enum NavigationMode {
  TermSet = 'TermSet',
  HubSite = 'HubSite',
}
